import { createRouter, createWebHistory } from 'vue-router';

const LoginView = () => import('@/views/LoginView.vue');
const SignUp = () => import('@/views/SignUpView.vue');
const ResetPassword = () => import('@/views/ResetPassword.vue');
const OTPLogin = () => import('@/views/OTPLogin.vue');
const HomeView = () => import('@/views/HomeView.vue');
const CertificateOfOrigin = () => import('@/views/CertificateOfOrigin.vue');
const EditCertificate = () => import('@/views/EditCertificate.vue');
const TransactionsView = () => import('@/views/TransactionsView.vue');
const OrderInvoice = () => import('@/components/CertificateOrigin/OrderInvoice.vue');
const ShowOrder = () => import('@/components/CertificateOrigin/ShowOrder.vue');
const ChamberTemplate = () => import('@/views/ChamberTemplate.vue');
const CertificateTemplate = () => import('@/views/CertificateTemplate.vue');
const ViewBook = () => import('@/views/ViewBook.vue');
const ViewCertificateA = () => import('@/views/ViewCertificateA.vue');
const ViewCertificateE = () => import('@/views/ViewCertificateE.vue');
const NotFound = () => import('@/views/404Page.vue');
const EditPassword = () => import('@/views/EditPassword.vue');
const ReDirectPage = () => import('@/views/ReDirectPage.vue');
const Profile = () => import('@/views/Profile.vue');
const DeleteAccount = () => import('@/views/DeleteAccount.vue');
const DeleteAccountStorpage = () => import('@/views/DeleteAccountStorpage.vue');

const routes = [
  { path: '/login', name: 'login', component: LoginView, meta: { hideNavBar: true, title: 'غرفة تجارة بغداد || تسجيل الدخول' } },
  { path: '/signup', name: 'signup', component: SignUp, meta: { hideNavBar: true, title: 'غرفة تجارة بغداد || انشاء حساب' } },
  { path: '/resetpassword', name: 'resetPassword', component: ResetPassword, meta: { hideNavBar: true, title: 'غرفة تجارة بغداد || اعادة تعيين كلمة المرور' } },
  { path: '/otp', name: 'otp', component: OTPLogin, meta: { hideNavBar: true, title: 'غرفة تجارة بغداد || تحقق من OTP' } },
  { path: '/', name: 'home', component: HomeView, meta: { title: 'غرفة تجارة بغداد || الصفحة الرئيسية' } },
  { path: '/origincertificate', name: 'originCertificate', component: CertificateOfOrigin, meta: { title: 'غرفة تجارة بغداد || طلب شهادة منشأ' } },
  { path: '/edit-certificate/:id', name: 'EditCertificate', component: EditCertificate, meta: { title: 'غرفة تجارة بغداد || تعديل طلب شهادة منشأ' } },
  { path: '/transactions', name: 'transactions', component: TransactionsView, meta: { title: 'غرفة تجارة بغداد || المعاملات' } },
  { path: '/DeleteAccount-Storpage', name: 'DeleteAccountStorpage', component: DeleteAccountStorpage, meta: { hideNavBar: true, title: 'غرفة تجارة بغداد || حسابي' } },
  { path: '/DeleteAccount', name: 'DeleteAccount', component: DeleteAccount, meta: { title: 'غرفة تجارة بغداد || حسابي' } },
  { path: '/profile-user', name: 'profile-user', component: Profile, meta: { title: 'غرفة تجارة بغداد || الملف الشخصي' } },
  { path: '/orderinvoice/:orderNumber', name: 'OrderInvoice', component: OrderInvoice, props: true, meta: { hideNavBar: true, title: 'غرفة تجارة بغداد' } },
  { path: '/showorder/:id', name: 'ShowOrder', component: ShowOrder, meta: { title: 'غرفة تجارة بغداد' } },
  { path: '/choicetype/:qrarchive', name: 'ChoiceTemplate', component: ChamberTemplate, meta: { hideNavBar: true, title: 'غرفة تجارة بغداد' } },
  { path: '/choicetypes/:idNumber', name: 'CertificateTemplates', component: CertificateTemplate, meta: { hideNavBar: true, title: 'غرفة تجارة بغداد' } },
  { path: '/viewbook/:bookid', name: 'ViewBook', component: ViewBook, meta: { hideNavBar: true, title: 'غرفة تجارة بغداد || الكتب' } },
  { path: '/viewcertificate/:certificateid', name: 'ViewCertificate', component: ViewCertificateA, meta: { hideNavBar: true, title: 'غرفة تجارة بغداد || شهادة المنشأ' } },
  { path: '/viewcertificateE/:certificateid', name: 'ViewCertificateEnglish', component: ViewCertificateE, meta: { hideNavBar: true, title: 'غرفة تجارة بغداد || Certificate of Origin' } },
  { path: '/edit-password', name: 'EditPassword', component: EditPassword, meta: { title: 'غرفة تجارة بغداد || تعديل كلمة المرور' } },
  {
    path: '/redirect',
    name: 'Redirect',
    meta: { hideNavBar: true, title: 'غرفة تجارة بغداد || أعادة توجيه' },
    children: [
      { path: 'books/:qrCode', name: 'Books', component: ReDirectPage },
      { path: 'certificates/:id', name: 'Certificates', component: ReDirectPage },
    ]
  },
  { path: '/:catchAll(.*)', name: 'NotFound', component: NotFound, meta: { hideNavBar: true, title: '404 NotFound' } },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('Token');
  const publicRoutes = [
    'login','signup','resetPassword','OrderInvoice','ChoiceTemplate',
    'CertificateTemplates','ShowCertificate','ViewCertificate','ViewBook',
    'ViewCertificateEnglish','Redirect','Books','Certificates','otp','DeleteAccountStorpage'
  ];

  document.title = to.meta.title || 'غرفة تجارة بغداد';

  if (!token && !publicRoutes.includes(to.name)) next('/login');
  else next();
});

export default router;
